<div class="main-container">
  <audio #audioPlayer controls [src]="audioUrl" hidden></audio>
  <div class="video-container">
    <video
      #videoPlayer
      width="100%"
      height="auto"
      controls
      preload="auto"
      [attr.src]="videoUrl"
      type="video/mp4"
      (error)="onVideoError()"
    >
      Not supported!
    </video>
  </div>

  <div class="segments-column">
    <div class="editor-toolbar">
      <div class="alle-ok-info" *ngIf="showAlleOkInfo">
        <span>
          Mit „Alle OK“ wird das Transkript als redaktionell abgenommen gespeichert –
          die Hinweise „Automatisch erstellte Untertitel“ (KI-UT) werden aus dem gelieferten XML entfernt.
        </span>
        <button class="info-dismiss" (click)="dismissAlleOkInfo()" title="Hinweis ausblenden">✕</button>
      </div>
      <div class="episode-id-field" *ngIf="isArchiveBroadcast">
        <label for="episodeIdInput">EpisodeID</label>
        <input id="episodeIdInput" type="text" inputmode="numeric" maxlength="15"
               [(ngModel)]="episodeId" [disabled]="episodeIdLocked || episodeIdSaving"
               [class.invalid]="episodeIdError"
               placeholder="z. B. 14152102"
               [title]="episodeIdLocked
                 ? 'Bei TvThek-Sendungen stammt die EpisodeID aus dem Ordnernamen.'
                 : 'EpisodeID wird beim Speichern mit „Alle OK“ übernommen und bestimmt den Dateinamen auf der Freigabe.'" />
      </div>
      <button class="ok-button ok-all-button" (click)="markAllAsOk()"
              [disabled]="episodeIdSaving"
              title="Alle Zeilen als korrigiert markieren und speichern">
        ✔ Alle OK
      </button>
    </div>

    <div class="episode-id-error" *ngIf="episodeIdError || transcriptError">{{ episodeIdError || transcriptError }}</div>

    <div class="scrollable-container">
    <div
      *ngFor="let segment of T?.segments; let i = index"
      class="segment-container"
    >
      <textarea
        #txtarea
        rows="1"
        [(ngModel)]="segment.text"
        (input)="autoResize(txtarea)"
        class="segment-textarea"
        (mousedown)="setCurrentAudioTime(segment)"
        (keydown)="onKeydown($event)"
        (click)="getCursorPosition($event, i)"
      ></textarea>
    </div>
    </div>
  </div>
</div>
